<template>
  <div>
    <div class="col-12">
      <ul class="nav nav-tabs">
        <li class="nav-item">
          <router-link v-if="channel.id"
            :to="{ name: `administration.channel-detail.info`, params: {id: channel.id}}"
            active-class="active"
            class="nav-link"
          >
            {{ channel.type | channelType }}
          </router-link>
        </li>
        <li class="nav-item" v-for="link in routerLinks" :key="link.title">
          <router-link v-if="channel.id"
            :to="{ name: `administration.channel-detail.${link.linkNameSuffix}`, params: {id: channel.id}}"
            active-class="active"
            class="nav-link"
          >
            {{ link.title }}
          </router-link>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
  import filter from 'ramda/src/filter'

  const allRouterLinks = [
    {linkNameSuffix: 'webhook', title: 'Webhook'},
    {linkNameSuffix: 'integrations', title: 'Integrations'},
    {linkNameSuffix: 'contacts', title: 'Contacts'},
    {linkNameSuffix: 'logs', title: 'Logs'},
    {linkNameSuffix: 'settings', title: 'Settings', channelSpecific: ['amio_chat']}
  ]

  export default {
    store: {
      channel: 'administration.channelDetail.channel'
    },

    computed: {
      routerLinks() {
        return filter((obj) => !obj.channelSpecific || obj.channelSpecific.includes(this.channel.type))(allRouterLinks)
      }
    }
  }
</script>
